export default {
  EmptyState: {
    title: 'Voeg uw eerste restaurant toe',
    description:
      'U heeft nog geen restaurants. Maak er een aan om te beginnen met instellen en bestellingen te ontvangen.',
    cta: 'Nieuw restaurant',
  },
};
